import { TableCell } from "@8x8/oxygen-table";
import React, { memo, useState } from "react";
import Tooltip from "@8x8/oxygen-tooltip";
import styled, { css } from "styled-components";

const FullWidthTableCell = styled(TableCell)`
  width: 100px;
`;

const TitleWrapper = styled.span`
  ${({ isCustomTooltip }) =>
    isCustomTooltip &&
    css`
      border-bottom: 1px dotted;
      cursor: help;
      text-decoration: underline;
      text-underline-offset: 2px;
    `};
`;

function HorizontalTableHeader({ title, tooltip }) {
  const [headerRef, setHeaderRef] = useState(undefined);
  const isCustomTooltip = title?.constructor === String && title !== tooltip;

  return (
    <FullWidthTableCell isHead>
      <TitleWrapper ref={setHeaderRef} isCustomTooltip={isCustomTooltip}>
        {title}
      </TitleWrapper>
      <Tooltip title={tooltip} includeWrapper={false} triggerRef={headerRef} />
    </FullWidthTableCell>
  );
}

export default memo(HorizontalTableHeader);
